(function () {
  // Map key -> real CSS background
  const MAP = {
    // NO/EN keys (lowercase)
    rod: '#e53935',
    rød: '#e53935',
    red: '#e53935',

    gronn: '#2e7d32',
    grønn: '#2e7d32',
    green: '#2e7d32',

    bla: '#1e88e5',
    blå: '#1e88e5',
    blue: '#1e88e5',

    gul: '#f9a825',
    yellow: '#f9a825',

    oransje: '#ff6600',
    oransj: '#ff6600',   // i tilfelle slugger kutter
    orange: '#ff6600',

    lilla: '#7e57c2',
    purple: '#7e57c2',

    gull: '#d4af37',
    gold: '#d4af37',

    svart: '#000000',
    sort: '#000000',
    black: '#000000',

    hvit: '#ffffff',
    white: '#ffffff',

    oliven: '#556b2f',
    olive: '#556b2f',

    // combos (både - og uten -)
    'sort-gul': 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    sortgul: 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    'sort-rod': 'linear-gradient(135deg, #000000 50%, #e53935 50%)',
    sortrod: 'linear-gradient(135deg, #000000 50%, #e53935 50%)',
    'sort-gronn': 'linear-gradient(135deg, #000000 50%, #2e7d32 50%)',
    sortgronn: 'linear-gradient(135deg, #000000 50%, #2e7d32 50%)',

    'black-yellow': 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    blackyellow: 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    'yellow-black': 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    yellowblack: 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    'gul-sort': 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    gulsort: 'linear-gradient(135deg, #000000 50%, #f9a825 50%)',
    'black-red': 'linear-gradient(135deg, #000000 50%, #e53935 50%)',
    blackred: 'linear-gradient(135deg, #000000 50%, #e53935 50%)',
    'black-green': 'linear-gradient(135deg, #000000 50%, #2e7d32 50%)',
    blackgreen: 'linear-gradient(135deg, #000000 50%, #2e7d32 50%)',
  };

  function normalizeKey(val) {
    return String(val || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '')     // fjern mellomrom
      .replace(/\//g, '-')     // sort/gul -> sort-gul
      ;
  }

  function resolveSwatches(root = document) {
    root.querySelectorAll('variant-swatch[style*="--background-graphic"]').forEach(el => {
      const raw = el.style.getPropertyValue('--background-graphic').trim();
      const key = normalizeKey(raw);
      const resolved = MAP[key];

      if (resolved) {
        el.style.setProperty('--swatch-resolved', resolved);
      } else {
        // fallback: hvis raw faktisk er gyldig CSS (f.eks. beige)
        el.style.setProperty('--swatch-resolved', raw);
      }
    });
  }

  // initial
  resolveSwatches();

  // re-run when theme rerenders options (variant change etc)
  const obs = new MutationObserver(() => resolveSwatches());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
(function () {
  const MAP = {
    // NO + EN (normalisert)
    sort: '#000000', svart: '#000000', black: '#000000',
    hvit: '#ffffff', white: '#ffffff',
    oliven: '#556b2f', olive: '#556b2f',
    beige: 'beige',
    gul: '#f9a825', yellow: '#f9a825',
    rod: '#e53935', red: '#e53935', // "rød" blir normalisert til "rod"
    gronn: '#2e7d32', green: '#2e7d32', // "grønn" -> "gronn"
    bla: '#1e88e5', blue: '#1e88e5', // "blå" -> "bla"
    oransje: '#ff6600', orange: '#ff6600',
    lilla: '#7e57c2', purple: '#7e57c2',
    gull: '#d4af37', gold: '#d4af37',

    // kombi (normalisert med '-' som separator)
    'sort-gul': 'linear-gradient(135deg,#000 50%,#f9a825 50%)',
    'sort-rod': 'linear-gradient(135deg,#000 50%,#e53935 50%)',
    'sort-gronn': 'linear-gradient(135deg,#000 50%,#2e7d32 50%)',

    'black-yellow': 'linear-gradient(135deg,#000 50%,#f9a825 50%)',
    'yellow-black': 'linear-gradient(135deg,#000 50%,#f9a825 50%)',
    'gul-sort': 'linear-gradient(135deg,#000 50%,#f9a825 50%)',
    'black-red': 'linear-gradient(135deg,#000 50%,#e53935 50%)',
    'black-green': 'linear-gradient(135deg,#000 50%,#2e7d32 50%)',
  };

  function norm(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      // norsk tegn -> ascii
      .replace(/ø/g, 'o')
      .replace(/å/g, 'a')
      .replace(/æ/g, 'ae')
      // mellomrom bort
      .replace(/\s+/g, '')
      // slash -> dash
      .replace(/\//g, '-');
  }

  function paintOne(variantSwatchEl) {
    if (!variantSwatchEl) return;

    const raw = variantSwatchEl.style.getPropertyValue('--background-graphic').trim();
    if (!raw) return;
    const rawIsImage =
      /^url\(/i.test(raw) ||
      /\.(png|jpe?g|webp|gif|svg)(\?|$)/i.test(raw);

    // Keep image swatches untouched (Shopify file/image swatches).
    if (rawIsImage || variantSwatchEl.classList.contains('is-image')) return;

    const key = norm(raw);
    const resolved = MAP[key] || MAP[norm(variantSwatchEl.getAttribute('swatch-id'))] || null;

    // Finn elementet som faktisk er synlig (prøver flere varianter i Venue)
    const label = variantSwatchEl.closest('label');
    const circle =
      (label && label.querySelector('.product-form__swatch__item--circle')) ||
      (label && label.querySelector('.product-form__swatch__label__graphic')) ||
      variantSwatchEl;

    if (!circle) return;

    // Reset først
    circle.style.background = '';
    circle.style.backgroundImage = '';
    circle.style.backgroundColor = '';

    const val = resolved || raw; // fallback til raw hvis det faktisk er gyldig (beige osv)

    if (String(val).startsWith('linear-gradient')) {
      circle.style.backgroundImage = val;
      circle.style.backgroundColor = 'transparent';
      circle.style.backgroundSize = 'cover';
      circle.style.backgroundRepeat = 'no-repeat';
    } else {
      circle.style.backgroundColor = val;
      circle.style.backgroundImage = 'none';
    }
  }

  function paintAll(root = document) {
    root.querySelectorAll('variant-swatch[style*="--background-graphic"]').forEach(paintOne);
  }

  // Kjør nå
  paintAll();

  // Kjør når swatches re-rendres (variantbytte / app / theme)
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        paintAll(document);
        break;
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // ekstra failsafe
  window.addEventListener('popstate', () => setTimeout(() => paintAll(), 0));
})();
